import React, { useMemo } from 'react';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import TreeNavigationView from '../../../components/ui-component/form-component/tree-view-navigation/TreeNavigationView';
import ApplicationContextProvider from '../../../context/ApplicationContext';
import { ZuwendungsantragStructure } from './structure/form/ZuwendungsantragStructure';
import { useEffect, useState } from 'react';
import { ErrorValidation, TreeNodeType } from '../../../lib/types/types';
import TreeNavigationButtons from '../../../components/ui-component/form-component/tree-view-navigation/TreeNavigationButtons';
import AntragRightSideBar from './AntragRightSideBar';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { APP_STATUS_EDITABLE, LOCATION_API_PATH } from '../../../lib/constants/constant';
import { get } from 'lodash';

import {
	constructHierarchyArray,
	extractIds,
} from '../../../components/ui-component/form-component/tree-view-navigation/TreeNavigatrionHelper';
import { cloneDeep } from 'lodash';
import { set } from 'lodash';
import PutRecord from '../../../lib/api/PutRecord';

import {
	checkErrorInCurrentNode,
	setHasBeenVisited,
	setShowError,
	validateAll,
} from '../../../lib/validation/validationHelperFunction';
import { GetFieldErrors } from '../../../lib/validation/ApplicationValidator';

import Population from '../../../lib/api/Populations.json';
import { isObjectEmpty, removeDataKeys, removeNullDeep } from '../../../utils/helper';
import { PushNotification } from '../../../lib/api/PushNotification';
import { Box, Tab, Tabs } from '@mui/material';
import GetRecord from '../../../lib/api/GetRecord';
import MuiDialog from '../../../components/ui-component/mui-dialog/MuiDialog';
import MuiSnackbar from '../../../components/ui-component/mui-snackbar/MuiSnackbar';
import { APIS } from '../../../lib/constants/apis';
import { isArray } from 'lodash';
import { PostRecord } from '../../../lib/api/PostRecord';
import { executeZuwendungsantragFormulas } from './formulas/zuwendungsantrag/zuwendungsantragFormulas';
import LoadingBackdrop from '../../../components/ui-component/loading/LoadingBackdrop';
import GetRecords from '../../../lib/api/GetRecords';
import { MittelabrufStructure } from './structure/mittelabruf/MittelabrufStructure';
import MessageIcon from '@mui/icons-material/Message';
import Schema from '../../../lib/paths/zuwendungsantrag_FULL_Paths.json';
import MittelabrufSchema from '../../../lib/paths/mittelabruf_FULL_Paths.json';
import VerwendungsnachweisSchema from '../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
import { VerwendungsnachweisStructure } from './structure/verwendungsnachweis/VerwendungsnachweisStructure';
import { executeVerwendungsFormulas } from './formulas/verwendungsnachweis/VerwendungsnachweisFormulas';
import ApplicationBreadcrumbs from './application-breadcrumbs/ApplicationBreadcrumbs';
import { ZuwendungsantragDependencies } from './structure/form/ZuwendungsAntragDependencies';
const P = Schema.attributes;
const MA_P = MittelabrufSchema.attributes;
const VN_P = VerwendungsnachweisSchema.attributes;

export default function OnlineAntrag() {
	const navigate = useNavigate();
	const [hasUnsavedAttributes, setHasUnsavedAttributes] = useState(false);
	const [treeStructure, setTreeStructure] = useState<TreeNodeType[]>([]);
	const [currentNode, setCurrentNode] = useState<string[]>(['1']);
	const [wsActive, setWsActive] = useState<boolean>(false);
	const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState<boolean>(false);
	const [appSubmitSuccess, setAppSubmitSuccess] = useState<boolean | null>(null);
	const [errors, setErrors] = useState<ErrorValidation[]>([]);
	const [storageHasBeenVisited, setStorageHasBeenVisited] = useState<boolean>(false);

	const location = useLocation();

	const { id } = useParams();
	const numericId = id ? parseInt(id) : -1;

	const [application, setApplication] = useState({});
	const [updates, setUpdates] = useState({});
	const [kostenKategories, setKostenKategories] = useState([]);
	const readOnly = useMemo(() => {
		return GetReadOnly(get(location, LOCATION_API_PATH), application);
	}, [application, location]);
	const IconRight = MessageIcon;

	const handleNavigation = (nodeIds: string[], buttonClick?: string) => {
		let hasErrorInCurrentNode = hasCurrentContentError();
		if (buttonClick === 'next' || buttonClick === 'previous') {
			const allNodesIdsArr = extractIds(treeStructure);
			const currentNodeStr = currentNode[currentNode.length - 1];
			const currentNodeIndex = allNodesIdsArr.findIndex((ele: any) => ele === currentNodeStr);

			if (currentNodeIndex !== -1) {
				const prevNodeStr = allNodesIdsArr[currentNodeIndex - 1];
				const nextNodeStr = allNodesIdsArr[currentNodeIndex + 1];

				if (buttonClick === 'next') {
					if (hasErrorInCurrentNode) return;
					saveApplication();
					setCurrentNode(constructHierarchyArray(nextNodeStr));
				}
				if (buttonClick === 'previous') {
					saveApplication();
					setCurrentNode(constructHierarchyArray(prevNodeStr));
				}
			}
		}
		if (Array.isArray(nodeIds) && nodeIds.length) {
			saveApplication();
			setCurrentNode(constructHierarchyArray(nodeIds[0], treeStructure));
		}
		const treeStruc = validateAll(updates,treeStructure,setErrors,readOnly,true);
		setTreeStructure(treeStruc);
	};

	const setApplicationProperty = (key: string, value: any) => {
		console.log('##################### set applicaiton property   \nPATH ', key, '\n And VALUE ', value);
		let appCopy = cloneDeep(updates);
		set(appCopy, key, value);
		const formulaFields = executeFormulas(appCopy, get(location, LOCATION_API_PATH), kostenKategories);
		if (isArray(formulaFields) && formulaFields.length > 0) {
			for (let ele of formulaFields) {
				set(appCopy, get(ele, 'path'), get(ele, 'value'));
			}
		}
		console.log('application after value setted ', appCopy);
		setHasUnsavedAttributes(true);
		setUpdates(appCopy);
	};
	const saveApplication = async (submit: boolean = false, newApplication: boolean | any = false) => {
		if (!hasUnsavedAttributes && newApplication === false && !submit) return;

		let updateRecord = newApplication || cloneDeep(updates);
		if (submit) {
			if (get(location, LOCATION_API_PATH) === APIS.Zuwendungsantrag) {
				set(updateRecord, P.Antragsstatus_Antragsstatus.path, 'eingegangen');
				if (!get(updateRecord, P.Allgemein_Eingereicht_Am.path)) {
					set(updateRecord, P.Allgemein_Eingereicht_Am.path, new Date());
				}
			}
			if (get(location, LOCATION_API_PATH) === APIS.Mittelabruf) {
				set(updateRecord, MA_P.Mittelabrufstatus_Mittelabrufstatus.path, 'eingegangen');
				if (!get(updateRecord, MA_P.Allgemein_Eingereicht_Am.path)) {
					set(updateRecord, MA_P.Allgemein_Eingereicht_Am.path, new Date());
				}
			}
			if (get(location, LOCATION_API_PATH) === APIS.Verwendungsnachweis) {
				set(updateRecord, VN_P.Verwendungsnachweisstatus_Status.path, 'eingegangen');

				if (!get(updateRecord, VN_P.Allgemein_Versandt_Am.path)) {
					set(updateRecord, VN_P.Allgemein_Versandt_Am.path, new Date());
				}
			}
			// if (get(location, LOCATION_API_PATH) === APIS.Zwischenbericht) {
			// 	set(updateRecord, ZB_P.Zwischenberichtstatus_Status.path, 'inPruefung');
			// 	if (!get(updateRecord, ZB_P.Allgemein_Eingereicht_Am.path)) {
			// 		set(updateRecord, ZB_P.Allgemein_Eingereicht_Am.path, new Date());
			// 	}
			// }
			// if (get(location, LOCATION_API_PATH) === APIS.Abschlussbericht) {
			// 	set(updateRecord, AB_P.Abschlussberichtstatus_Abschlussberichtsstatus.path, 'inPruefung');
			// 	if (!get(updateRecord, AB_P.Allgemein_Eingereicht_Am.path)) {
			// 		set(updateRecord, AB_P.Allgemein_Eingereicht_Am.path, new Date());
			// 	}
			// }
		}
		console.log(' update record BEFORE PUT AUFRUF ', updateRecord);
		try {
			setWsActive(true);
			let updatedRecord = await updateRelations(updateRecord, get(location, LOCATION_API_PATH));
			let res = await PutRecord(
				get(location, LOCATION_API_PATH),
				get(updatedRecord, 'id'),
				{ data: get(updatedRecord, 'attributes') },
				get(Population, `${get(location, LOCATION_API_PATH).replace(/.$/, '')}.FULL`),
			);
			if (res && submit) {
				setAppSubmitSuccess(true);
				await PushNotification(get(location, LOCATION_API_PATH), updatedRecord);
			}
			setApplication(removeNullDeep(removeDataKeys(get(res, 'data', []))));
			setUpdates(removeNullDeep(removeDataKeys(get(res, 'data', []))));
		} catch (err: any) {
			console.error('ERROR: Update Applicatoin ', err);
		} finally {
			setHasUnsavedAttributes(false);
			setWsActive(false);
			setOpenSuccessSnackbar(true);
		}
	};

	const findNodeContent = (nodes: TreeNodeType[], nodeId: any[]): JSX.Element | null => {
		for (const node of nodes) {
			if (node.children) {
				const foundContent = findNodeContent(node.children, nodeId);

				if (foundContent) {
					return (
						<>
							{node.content}
							{/* Show tabs if > 1 */}
							{node.children.length > 1 && (
								<Tabs
									value={nodeId[1]}
									variant="scrollable"
									scrollButtons="auto"
									aria-label="scrollable auto tabs example"
									onChange={(_e, newId) => {
										handleNavigation([newId]);
									}}
								>
									{node.children.map((ele, i) => {
										return (
											<Tab
												key={i}
												value={ele.id}
												label={ele.label}
												icon={ele.hasComment ? <IconRight sx={{ color: 'primary.main' }} /> : <></>}
												iconPosition="end"
												sx={{ color: ele.showError ? 'error.main' : null }}
											/>
										);
									})}
								</Tabs>
							)}
							{foundContent}
						</>
					);
				}
			}
			if (node.id === nodeId[nodeId.length - 1]) {
				return node.content;
			}
		}
		return null;
	};

	function hasCurrentContentError(): boolean {
		if (treeStructure.length <= 0) return false;

		const antragId = get(application, 'id');
		// get current content and compare path with errorList
		const errorList = GetFieldErrors(treeStructure, updates, readOnly);
		setErrors(errorList);
		const curNode = currentNode[currentNode.length - 1];
		let hasError = checkErrorInCurrentNode(treeStructure, errorList, curNode);
		let structure = [...treeStructure];
		if (Number(curNode) > 0) {
			setShowError(treeStructure, currentNode, hasError);
			setHasBeenVisited(structure, currentNode);
			setTreeStructure(structure);
		}
		if (!storageHasBeenVisited) {
			localStorage.setItem(antragId, JSON.stringify(true));
			setStorageHasBeenVisited(true);
		}
		return hasError;
	}

	const validateCompleteForm = () => {
		let structure = validateAll(application, treeStructure, setErrors, readOnly);
		setTreeStructure(structure);
	};

	const renderContent = () => {
		if (!currentNode) {
			return null;
		}
		return findNodeContent(treeStructure, currentNode);
	};

	useEffect(() => {
		setTreeStructure(
			GetTreeStructure(
				get(location, LOCATION_API_PATH),
				updates,
				treeStructure,
				readOnly,
				storageHasBeenVisited,
				setStorageHasBeenVisited,
				setErrors,
				kostenKategories,
			),
		);
	}, [application, kostenKategories, location, updates]);

	useEffect(() => {
		const fetchApp = async () => {
			try {
				setWsActive(true);
				let res = await GetRecord(
					get(location, LOCATION_API_PATH),
					numericId,
					get(Population, `${get(location, LOCATION_API_PATH).replace(/.$/, '')}.FULL`),
				);
				const app = removeNullDeep(removeDataKeys(get(res, 'data', [])));
				let kostenKategoriesRes = await GetRecords(APIS.KostenKategories, [], {
					Allgemein_Foerderprogramm: { $contains: get(app, 'data.id') },
				});
				setKostenKategories(removeNullDeep(removeDataKeys(get(kostenKategoriesRes, 'data', []))));
				setApplication(app);
				setUpdates(app);
			} catch (err: any) {
				console.error('ERROR: Fetching Application ', err);
			} finally {
				setWsActive(false);
			}
		};
		fetchApp();
	}, [location, numericId]);

	const DialogContent = useMemo(() => {
		switch (get(location, LOCATION_API_PATH)) {
			case APIS.Zuwendungsantrag:
				if (get(updates, P.Allgemein_Typ.path) === 'Skizze') return 'Ihr Skizze wurde erfolgreich eingereicht';
				return 'Ihr Antrag wurde erfolgreich eingereicht';
			case APIS.Mittelabruf:
				return 'Ihr Mittelabruf wurde erfolgreich eingereicht';
			case APIS.Verwendungsnachweis:
				return 'Ihr Verwendungsnachweis wurde erfolgreich eingereicht';
			// case APIS.Zwischenbericht:
			// 	return 'Ihr Zwischenbericht wurde erfolgreich eingereicht';
			// case APIS.Abschlussbericht:
			// 	return 'Ihr Abschlussbericht wurde erfolgreich eingereicht';
			default:
				return 'Ihr Antrag wurde erfolgreich eingereicht';
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	console.log(' updates ', updates);

	return (
		<>
			<LoadingBackdrop open={wsActive} />
			<Box sx={{ paddingLeft: '1.5rem', paddingRight: '1.5rem' }}>
				<ApplicationContextProvider
					application={updates}
					setApplicationProperty={setApplicationProperty}
					saveApplication={saveApplication}
					tree={treeStructure}
					errors={errors}
					readOnly={readOnly}
				>
					<MuiDialog
						open={appSubmitSuccess}
						onClose={() => {
							setAppSubmitSuccess(false);
							navigate('/meine-antraege');
						}}
						onCloseButtonName="Zurück zu meinen Anträgen"
						title={'Erfolg'}
						content={DialogContent}
					/>
					<MuiSnackbar
						showSnackbar={openSuccessSnackbar}
						closeSnackbar={() => setOpenSuccessSnackbar(false)}
						alertMessage="Antrag gesichert"
					/>
					<Grid container columns={12} spacing={6} sx={{ mt: '1rem', padding: '0 1rem', minHeight: '80vh' }}>
						<Grid sm={0} md={2}>
							<TreeNavigationView
								treeStructure={treeStructure}
								currentNode={currentNode}
								handleNavigation={handleNavigation}
							/>
						</Grid>
						<Grid sm={12} md={8} sx={{ display: 'flex', flexDirection: 'column' }}>
							<ApplicationBreadcrumbs api={get(location, LOCATION_API_PATH)} />
							{renderContent()}
							<TreeNavigationButtons
								treeStructure={treeStructure}
								currentNode={currentNode}
								handleNavigation={handleNavigation}
								hasCurrentContentError={hasCurrentContentError}
								validateCompleteForm={validateCompleteForm}
							/>
						</Grid>
						<Grid sm={0} md={2} sx={{ mt: '4rem' }}>
							<AntragRightSideBar api={get(location, LOCATION_API_PATH)} />
						</Grid>
					</Grid>
				</ApplicationContextProvider>
			</Box>
		</>
	);
}
const GetReadOnly = (api: string, application: any) => {
	switch (api) {
		case APIS.Zuwendungsantrag:
			return !APP_STATUS_EDITABLE.includes(get(application, P.Antragsstatus_Antragsstatus.path));
		case APIS.Mittelabruf:
			return !APP_STATUS_EDITABLE.includes(get(application, MA_P.Mittelabrufstatus_Mittelabrufstatus.path));
		case APIS.Verwendungsnachweis:
			return !APP_STATUS_EDITABLE.includes(get(application, VN_P.Verwendungsnachweisstatus_Status.path));
		// case APIS.Zwischenbericht:
		// 	return !APP_STATUS_EDITABLE.includes(get(application, ZB_P.Zwischenberichtstatus_Status.path));
		// case APIS.Abschlussbericht:
		// 	return !APP_STATUS_EDITABLE.includes(get(application, AB_P.Abschlussberichtstatus_Abschlussberichtsstatus.path));

		default:
			return true;
	}
};

const GetTreeStructure = (
	api: string,
	application: any,
	treeStructure: TreeNodeType[],
	readOnly: boolean,
	storageHasBeenVisited: boolean,
	setStorageHasBeenVisited: any,
	setErrors: any,
	kostenKategories?: any,
): TreeNodeType[] => {
	switch (api) {
		case APIS.Zuwendungsantrag:
			return getMappedTreeStructure(
				application,
				ZuwendungsantragStructure(application, kostenKategories, readOnly),
				treeStructure,
				storageHasBeenVisited,
				setStorageHasBeenVisited,
				setErrors,
				readOnly,
			);
		case APIS.Mittelabruf:
			return getMappedTreeStructure(
				application,
				MittelabrufStructure(),
				treeStructure,
				storageHasBeenVisited,
				setStorageHasBeenVisited,
				setErrors,
				readOnly,
			);
		case APIS.Verwendungsnachweis:
			return getMappedTreeStructure(
				application,
				VerwendungsnachweisStructure(application, kostenKategories),
				treeStructure,
				storageHasBeenVisited,
				setStorageHasBeenVisited,
				setErrors,
				readOnly,
			);
		default:
			return [];
	}
};
const updateRelations = async (application: any, api: string) => {
	let appCopy = cloneDeep(application);
	let updateDependencies = GetUpdateDependencies(appCopy, api);

	// POST or PUT for the relation
	for (let relation of get(updateDependencies, 'relations', [])) {
		let path = get(relation, 'field');
		let value = get(appCopy, path, []);
		let api = get(relation, 'api');
		if (isArray(value)) {
			for (let index in value) {
				await upsertRelation(appCopy, path + '.' + index, api);
			}
		} else {
			await upsertRelation(appCopy, path, api);
		}
	}
	return appCopy;
};
const upsertRelation = async (application: any, path: string, api: string) => {
	let data = { data: get(application, path + '.attributes', {}) };
	if (isObjectEmpty(get(data, 'data', ''))) return;

	let id = get(application, path + '.id');
	if (id) {
		await PutRecord(api, id, data);
	} else {
		let res = await PostRecord(api, data);
		set(application, path, get(res, 'data.id', null));
	}
};

export const GetUpdateDependencies = (application: any, api: string) => {
	switch (api) {
		case APIS.Zuwendungsantrag:
			return ZuwendungsantragDependencies(application);
		default:
			return [];
	}
};

const executeFormulas = (application: any, api: string, kostenKategories: any) => {
	if (api === APIS.Zuwendungsantrag) {
		return executeZuwendungsantragFormulas(application, kostenKategories);
	}
	if (api === APIS.Verwendungsnachweis) {
		return executeVerwendungsFormulas(application, kostenKategories);
	}
	return [];
};

const mapAndGetTreeErrorNavigation = (initialTree: TreeNodeType[], treeStructure: TreeNodeType[]) => {
	let currentTree = [...treeStructure];
	const updatedTree = replaceFormStruc(currentTree, initialTree);
	return updatedTree;
};

const getMappedTreeStructure = (
	application: any,
	initialTree: TreeNodeType[],
	treeStructure: TreeNodeType[],
	storageHasBeenVisited: boolean,
	setStorageHasBeenVisited: any,
	setErrors: any,
	readOnly: boolean,
): TreeNodeType[] => {
	const initial = treeStructure.length <= 0 && get(application, 'attributes');

	if (initial) {
		const antragId = get(application, 'id');
		const formHasBeenVisited = localStorage.getItem(antragId) ? localStorage.getItem(antragId) : false;
		if (formHasBeenVisited && !storageHasBeenVisited) {
			setStorageHasBeenVisited(true);
			return validateAll(application, initialTree, setErrors, readOnly);
		}
		return initialTree;
	} else if (treeStructure.length > 0 && get(application, 'attributes')) {
		const antragId = get(application, 'id');
		const formHasBeenVisited = localStorage.getItem(antragId) ? localStorage.getItem(antragId) : false;
		if (formHasBeenVisited && !storageHasBeenVisited) {
			setStorageHasBeenVisited(true);
			return validateAll(application, treeStructure, setErrors, readOnly);
		} else {
			return mapAndGetTreeErrorNavigation(initialTree, treeStructure);
		}
	}
	return [];
};

const replaceFormStruc = (oldTree: TreeNodeType[], initialTree: TreeNodeType[]) => {
	return initialTree.map((item: TreeNodeType) => {
		const result = findNodeByLabel(oldTree, item.label);
		const node = result ? result : item;
		let formStruc;
		let children;
		if (item.formStruc) {
			formStruc = {
				formStruc: item.formStruc,
			};
		}
		if (item.children) {
			children = {
				children: item.children.map((child) => {
					const resultChild = findNodeByLabel(oldTree, item.label, child.label);
					const nodeChild = resultChild ? resultChild : child;

					return {
						...child,
						showError: nodeChild.showError,
						hasBeenVisited: nodeChild.hasBeenVisited,
						formStruc: child.formStruc,
					};
				}),
			};
		}
		return {
			...item,
			showError: node.showError,
			hasBeenVisited: node.hasBeenVisited,
			...formStruc,
			...children,
		};
	});
};

const findNodeById = (tree: TreeNodeType[], id: string): TreeNodeType | null => {
	for (const node of tree) {
		if (node.id === id) {
			return node;
		}

		if (node.children) {
			const foundInChildren = findNodeById(node.children, id);
			if (foundInChildren) {
				return foundInChildren;
			}
		}
	}
	return null;
};
const findNodeByLabel = (tree: TreeNodeType[], parentLabel: string, childLabel?: string): TreeNodeType | null => {
	for (const node of tree) {
		if (!childLabel && node.label === parentLabel) return node;

		if (childLabel === node.label) return node;

		if (childLabel && node.children && node.label === parentLabel) {
			const foundInChildren = findNodeByLabel(node.children, parentLabel, childLabel);
			if (foundInChildren) {
				return foundInChildren;
			}
		}
	}
	return null;
};
